export default __webpack_public_path__ + "static/media/esri-streets.90127cac.png";